<template>

<!-- <div class="wardrobe-main l_wrap"> -->

<div class="wardrobe-main l_specs" style="width: 100%;">

  <div class="wardrobe-specs">

    <div class="wardrobe-spec">
      <div class="wardrobe-spec-inner" v-if="props.item.specs.description">
        <p class="wardrobe-spec-title">Product description:</p>
        <div class="wardrobe-spec-text" v-html="props.item.specs.description" style="white-space: pre;">
        </div>
      </div>
    </div>

  </div>

</div>

<div class="wardrobe-main l_specs" v-if="tilesLarge.length || tilesAuto.length">

  <div class="wardrobe-specs">

    <div class="wardrobe-spec l_w100">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Design</p>

        <div class="wardrobe-spec-text">
          <div class="features s_open l_quote">
            <div class="features-body">
              <div class="features-body-inner l_flex l_flex-wrap l_stretch">

                <button
                  v-for="tile in tilesLarge"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview height--auto"
                  :class="[
                    tilesLarge.length == 1 ? 'width--100' : 'width--50',
                  ]">
                  <div class="opt-inner">
                    <div class="opt-tag" v-if="tile.label.length">
                      <span v-html="tile.label"></span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${tile.imageUrl});`" v-if="tile.imageUrl"></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="tile.title">
                        <strong v-html="tile.title"></strong>
                        <!-- <br v-if="props.item.data.doorProfile.tag" /><span v-html="props.item.data.doorProfile.tag" v-if="props.item.data.doorProfile.tag"></span> -->
                      </div>
                    </div>
                  </div>
                </button>

                </div>
                <div class="features-body-inner l_flex l_flex-wrap l_stretch">

                <button
                  v-for="tile in tilesAuto"
                  class="opt l_visual l_interiors l_frameless l_config l_overview l_selections-overview"
                  :class="tilesAutoGrid">
                  <div class="opt-inner">
                    <div class="opt-tag" v-if="tile.label.length">
                      <span v-html="tile.label"></span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${tile.imageUrl});`" v-if="tile.imageUrl"></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="tile.title">
                        <strong v-html="tile.title"></strong>
                        <!-- <br v-if="props.item.data.doorProfile.tag" /><span v-html="props.item.data.doorProfile.tag" v-if="props.item.data.doorProfile.tag"></span> -->
                      </div>
                    </div>
                  </div>
                </button>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</div>

<!-- </div> -->

</template>

<script setup>

import { ref, computed } from 'vue'

var _ = require('lodash');

const props = defineProps([
  'item'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['selectOption'])

const tilesLarge = computed(() => {
  if (_.isNil(props.item.data.tiles)) return [];
  return props.item.data.tiles.filter(tile => tile.size == 'large');
});

const tilesAuto = computed(() => {
  if (_.isNil(props.item.data.tiles)) return [];
  return props.item.data.tiles.filter(tile => tile.size !== 'large');
});

const tilesAutoGrid = computed(() => {
  let gridClass = 'l_trio';
  if (tilesAuto.value.length == 4) gridClass = 'l_fourup';
  if (tilesAuto.value.length >= 7) gridClass = 'l_fourup';
  return gridClass;
});

function lightboxActivate(e, item, zoomType) {
  emit('lightboxActivate', item, zoomType);
  e.preventDefault();
  return false;
}

function booleanToText(value) {
  if (value) return 'Yes';
  return 'No';
}

function benchCutoutsDisplay(value) {
  if (value == 0) return 'None';
  return value;
}


let refHandles = [];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});

</script>
